import { a as r } from "../internals/array-with.js";
import { a as t } from "../internals/array-buffer-view-core.js";
import { i } from "../internals/is-big-int-array.js";
import { t as a } from "../internals/to-integer-or-infinity.js";
import { t as n } from "../internals/to-big-int.js";
var o = t.aTypedArray,
  e = t.getTypedArrayConstructor;
(0, t.exportTypedArrayMethod)("with", {
  with: function _with(t, s) {
    var f = o(this),
      y = a(t),
      m = i(f) ? n(s) : +s;
    return r(f, e(f), y, m);
  }
}.with, !function () {
  try {
    new Int8Array(1).with(2, {
      valueOf: function valueOf() {
        throw 8;
      }
    });
  } catch (r) {
    return 8 === r;
  }
}());